import axios from "axios";
import { errorMessage } from "./toastifyShowMessage";
import { HandleServicesError } from "./swalModal";
import { CheckToken, clearApp, getLocalStorage, setAuthorization, setToken } from "./services";
import { _adr, _ckey } from "../address";
import { delay } from "./tools";

// ساختار دریافت و پست کردن دیتا
const QueryAPI = async ({ url = "", parameters = {}, type = "post", contentType = "application/json; charset=utf-8" }) => {
  let response = null;
  setAuthorization(getLocalStorage(_ckey.token));
  try {
    const apiUrl = process.env.REACT_APP_API_KEY + url;
    if (type === "post") {
      response = await axios.post(apiUrl, parameters, {
        timeout: 30000,
        headers: {
          "Content-Type": contentType,
        },
      });
    } else {
      response = await axios.get(apiUrl, { timeout: 30000 });
    }
    if (response.data.HasError) {
      if (response.data.Code === 1127) {
        await clearApp();
        window.location.href = _adr.Root + _adr.Security.Login;
      } else {
        errorMessage(response.data.Message);
        return null;
      }
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      console.error("An error occurred", error.code);
      clearApp();
      HandleServicesError();
    } else {
      if (process.env.REACT_APP_DOMAIN === "dealer") {
        errorMessage(
          <div dir="ltr" style={{ textAlign: "left" }}>
            {error?.code} <br />
            {error?.message} <br />
            {error?.config?.url} <br />
            <div dir="ltr">{JSON.stringify(JSON.parse(error?.config?.data), undefined, 2)}</div>
          </div>,
        );
      } else {
        // errorMessage(
        //   <div>
        //     {error?.code} <br />
        //     {error?.message} <br />
        //     {error?.config?.url} <br />
        //   </div>,
        // );
        errorMessage("درحال حاضر سرویس در دسترس نمی‌باشد");
      }
    }
  }
  return response ? response.data : null;
};

const createApiTokenBySession = async (parameters) => {
  let response = null;
  response = await QueryAPI({ url: "/public/Security/CreateAPITokenBySession", parameters: parameters });
  return response ? response?.Result : null;
};
export const useAPIPublic = () => {
  //لاگین به سرویس
  const login = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/Login", parameters: parameters });
    return response ? response.Result : null;
  };

  //دریافت درصد مالیات
  const queryTaxPercent = async () => {
    let response = null;
    response = await QueryAPI({ url: "/public/BaseInfo/QueryTaxPercent", type: "GET" });
    return response ? response.Result : null;
  };
  //دریافت توکن برای دسترسی به کیف پول
  const accessAsanWallet = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/AccessAsanWallet", parameters: parameters });
    return response ? response?.Result : null;
  };
  //ارسال کد OTP
  const sendOTPCodeAsync = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/SendOTPCodeAsync", parameters: parameters });
    return response ? response?.Result : null;
  };
  //ارسال مجدد کد OTP
  const resendOTPCode = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/ResendOTPCode", parameters: parameters });
    return response ? response?.Result : null;
  };
  //تایید کد OTP
  const confirmOTPCode = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/ConfirmOTPCode", parameters: parameters });
    return response ? response : null;
  };
  //دریافت اطلاعات مربوط به کاربر
  const queryCurrentUser = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/QueryCurrentUser", type: "Get" });
    if (response === null) {
      await clearApp();
      window.location.href = _adr.Root + _adr.Security.Login;
    } else {
      return response ? response : null;
    }
  };
  //جنسیت
  const queryGender = async () => {
    let response = null;
    response = await QueryAPI({ url: "/public/BaseInfo/QueryGender", type: "GET" });
    return response ? response.Result : null;
  };
  // دریافت اطلاعات کاربر
  const queryCurrentUserVProfile = async () => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/QueryCurrentUserVProfile", type: "GET" });
    if (response === null) {
      await clearApp();
      window.location.href = _adr.Root + _adr.Security.Login;
      return null;
    } else {
      return response ? response.Result : null;
    }
  };
  //لیست استان ها
  const queryActiveProvince = async () => {
    let response = null;
    response = await QueryAPI({ url: "/public/BaseInfo/QueryActiveProvince", type: "GET" });
    return response ? response.Result : null;
  };
  // دریافت اطلاعات استان و شهر
  const queryCityByCityId = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/BaseInfo/QueryCityByCityId?cityid=" + parameters, type: "GET" });
    return response ? response.Result : null;
  };
  //لیست شهر ها براساس استان
  const queryActiveCityByProvinceId = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/BaseInfo/QueryActiveCityByProvinceId?provinceid=" + parameters, type: "GET" });
    return response ? response.Result : null;
  };
  //resetPassword
  const resetPassword = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/resetPassword", parameters: parameters });
    return response ? response : null;
  };

  //بارگذاری فایل
  const addDocument = async (request, queryString) => {
    let response = null;
    response = await QueryAPI({
      url: `/public/Document/AddDocument?doctype=${queryString}`,
      parameters: request,
      contentType: "multipart/form-data",
    });
    await delay();
    return response ? response : null;
  };
  //دریافت فایل بارگذاری شده
  const getDocument = async (request) => {
    let response = null;
    response = await QueryAPI({ url: `/public/Document/GetDocument?docid=${request}`, type: "GET" });
    return response ? response.Result : null;
  };
  //دریافت لیست کیف پول
  const queryWalletType = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/BaseInfo/QueryWalletType", type: "Get" });
    return response ? response.Result : null;
  };

  //ارسال OTP
  const queryOTPIsRequired = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/QueryOTPIsRequired", parameters: parameters });
    return response ? response.Result : null;
  };

  //دریافت دلایل تعویض سیم کارت
  const querySimSwapReason = async () => {
    let response = null;
    response = await QueryAPI({ url: "/public/BaseInfo/QuerySimSwapReason", type: "GET" });
    return response ? response.Result : null;
  };

  //دریافت لیست مدارک
  const queryCertType = async () => {
    let response = null;
    response = await QueryAPI({ url: "/public/BaseInfo/QueryCertType", type: "GET" });
    return response ? response.Result : null;
  };

  //دریاف لیست کشورها
  const queryActiveCountry = async () => {
    let response = null;
    response = await QueryAPI({ url: "/public/BaseInfo/QueryActiveCountry", type: "GET" });
    return response ? response.Result : null;
  };

  //دریافت زبان
  const queryActiveLanguage = async () => {
    let response = null;
    response = await QueryAPI({ url: "/public/BaseInfo/QueryActiveLanguage", type: "GET" });
    return response ? response.Result : null;
  };

  //دریافت حداقل برداشت
  const queryMinimumAmountGetCashFromWallet = async () => {
    let response = null;
    response = await QueryAPI({ url: "/public/BaseInfo/QueryMinimumAmountGetCashFromWallet", type: "GET" });
    return response ? response.Result : null;
  };

  //برداشت از اعتبار
  const withdrawUserWallet = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/WithdrawUserWallet", parameters: parameters });
    return response ? response.Result : null;
  };

  //رفرش توکن
  const refreshToken = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/RefreshToken", parameters: parameters });
    return response ? response.Result : null;
  };
  //بروزرسانی کلمه عبور
  const updateUserPassword = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/UpdateUserPassword", parameters: parameters });
    return response ? response.Result : null;
  };

  //دریافت نقش کاربر
  const queryUserRoles = async () => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/QueryUserRoles", type: "GET" });
    return response ? response.Result : null;
  };

  //اپدیت اطلاعات بانک
  const updateUserBankAcountInfo = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/UpdateUserBankAcountInfo", parameters: parameters });
    return response ? response : null;
  };

  return {
    createApiTokenBySession,
    login,
    queryTaxPercent,
    accessAsanWallet,
    sendOTPCodeAsync,
    resendOTPCode,
    confirmOTPCode,
    queryCurrentUser,
    resetPassword,
    queryGender,
    queryActiveProvince,
    queryCityByCityId,
    queryActiveCityByProvinceId,
    addDocument,
    queryWalletType,
    queryOTPIsRequired,
    querySimSwapReason,
    queryCertType,
    queryActiveCountry,
    queryActiveLanguage,
    getDocument,
    queryMinimumAmountGetCashFromWallet,
    withdrawUserWallet,
    refreshToken,
    updateUserPassword,
    queryUserRoles,
    updateUserBankAcountInfo,
    queryCurrentUserVProfile,
  };
};
export const useSecurity = () => {
  // افزایش اعتبار کیف پول
  const increaseWalletByBankGateWay = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/IncreaseWalletByBankGateWay", parameters: parameters });
    return response ? response.Result : null;
  };
  //برگشت از بانک آسان پرداخت
  const callBackIPGAsanPardakht = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/CallBackIPGAsanPardakht", parameters: parameters });
    return response ? response : null;
  };
  //برگشت از بانک پارسیان
  const callBackIPGParsian = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/CallBackIPGParsian", parameters: parameters });
    return response ? response.Result : null;
  };
  // دریافت لیست درگاه ها
  const queryGateWayByPlanId = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/QueryGateWayByPlanId", parameters: parameters });
    return response ? response.Result : null;
  };

  const freezeWalletAmount = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/public/Security/FreezeWalletAmount", parameters: parameters });
    return response ? response : null;
  };

  return {
    increaseWalletByBankGateWay,
    callBackIPGAsanPardakht,
    callBackIPGParsian,
    queryGateWayByPlanId,
    freezeWalletAmount,
  };
};

export const useTenders = () => {
  //
  const SubmitBidInTender = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/Bid/SubmitBidInTender", parameters: parameters });
    return response ? response : null;
  };
  const addProfile = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/IdentityInformation/AddProfile", parameters: parameters });
    return response ? response.Result : null;
  };
  const addAddress = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/IdentityInformation/AddAddress", parameters: parameters });
    return response ? response : null;
  };

  const queryCountSimCardByCertNo = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/IdentityInformation/QueryCountSimCardByCertNo", parameters: parameters });
    return response ? response : null;
  };
  const queryProfileByCertNoVBirthDate = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/IdentityInformation/QueryProfileByCertNoVBirthDate", parameters: parameters });
    return response ? response.Result : null;
  };
  const queryDeliveryAddressByProfileId = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/IdentityInformation/QueryDeliveryAddressByProfileId", parameters: parameters });
    return response ? response.Result : null;
  };
  const updateDocumentProfile = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/IdentityInformation/UpdateDocumentProfile", parameters: parameters });
    return response ? response.Result : null;
  };
  const addressByPostcode = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/IdentityInformation/AddressByPostcode", parameters: parameters });
    return response ? response.Result : null;
  };
  const accuratePosition = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/IdentityInformation/AccuratePosition", parameters: parameters });
    return response ? response.Result : null;
  };
  //لیست حراج شماره
  const queryTenderNumbers = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/Introduction/QueryTenderNumbers", parameters: parameters });
    const result = response ? response.Result : null;
    if (!Array.isArray(result)) return result;

    // یک کپی از خروجی مرتب می‌شود تا آرایه‌ی پاسخ API تغییر نکند.
    // تاریخ‌های جدیدتر ابتدا و تاریخ‌های نامعتبر یا خالی در انتهای لیست قرار می‌گیرند.
    return [...result].sort((firstItem, secondItem) => {
      const firstStartDate = Date.parse(firstItem?.startDate);
      const secondStartDate = Date.parse(secondItem?.startDate);
      const firstIsValid = Number.isFinite(firstStartDate);
      const secondIsValid = Number.isFinite(secondStartDate);

      if (!firstIsValid && !secondIsValid) return 0;
      if (!firstIsValid) return 1;
      if (!secondIsValid) return -1;
      return secondStartDate - firstStartDate;
    });
  };
  const queryTenderNumberById = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: `/auction/Introduction/QueryTenderNumberById?tenderid=${parameters}`, parameters: "" });
    return response ? response.Result : null;
  };
  const redirectToNeginWalletGateWay = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: `/auction/Payment/RedirectToNeginWalletGateWay`, parameters: "" });
    return response ? response.Result : null;
  };
  const queryDetailOfChangeWallet = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: `/auction/Report/QueryDetailOfChangeWallet`, parameters: "" });
    return response ? response.Result : null;
  };
  const queryWalletByDate = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: `/auction/Report/QueryWalletByDate`, parameters: parameters });
    return response ? response : null;
  };
  const queryTenderBidders = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/Report/QueryTenderBidders", parameters: parameters });
    return response ? response : null;
  };
  const querySummerOfTenderBidders = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/Report/QuerySummerOfTenderBidders", parameters: parameters });
    return response ? response.Result : null;
  };
  const queryCurrentUserBids = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/Report/QueryCurrentUserBids", parameters: parameters });
    return response ? response : null;
  };
  const userPaidDeposit = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/Payment/UserPaidDeposit", parameters: parameters });
    return response ? response : null;
  };

  const paidBidTenderByCustomer = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/Payment/PaidBidTenderByCustomer", parameters: parameters });
    return response ? response : null;
  };
  //جستجوی شماره‌های رند پیشنهادی براساس الگو
  const querySuggestionTenderNumbers = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/Introduction/QuerySuggestionTenderNumbers", parameters: parameters });
    return response ? response.Result : null;
  };
  //شروع پروسه مزایده برای شماره انتخابی
  const startAuctionProcessForMSISDN = async (parameters) => {
    let response = null;
    response = await QueryAPI({ url: "/auction/Payment/StartAuctionProcessForMSISDN", parameters: parameters });
    return response ? response : null;
  };

  return {
    SubmitBidInTender,
    addProfile,
    addAddress,
    queryCountSimCardByCertNo,
    queryProfileByCertNoVBirthDate,
    queryDeliveryAddressByProfileId,
    updateDocumentProfile,
    addressByPostcode,
    accuratePosition,
    queryTenderNumbers,
    queryTenderNumberById,
    redirectToNeginWalletGateWay,
    queryDetailOfChangeWallet,
    queryWalletByDate,
    queryTenderBidders,
    querySummerOfTenderBidders,
    queryCurrentUserBids,
    userPaidDeposit,
    paidBidTenderByCustomer,
    querySuggestionTenderNumbers,
    startAuctionProcessForMSISDN,
  };
};
